import reduxCookiesMiddleware from './reduxCookiesMiddleware';
import getStateFromCookies from './getStateFromCookies';

export { getStateFromCookies };
export default reduxCookiesMiddleware;
